import { z } from 'zod';

const HerdAnimals = z.object({
    Alpaca: z.never(),
    Cow: z.enum(['Cattle', 'Bull', 'Calf']),
    Deer: z.never(),
    Goat: z.never(),
    Horse: z.never(),
    Pig: z.never(),
    Sheep: z.never(),
});

export const AnimalSpeciesEnum = HerdAnimals.keyof();
export type AnimalSpecies = z.infer<typeof AnimalSpeciesEnum>;

export type HerdType = z.infer<typeof HerdAnimals>[keyof z.infer<typeof HerdAnimals>];

export const getHerdType = <T extends keyof typeof HerdAnimals.shape>(species: T) => {
    if (species == 'Cow') {
        return HerdAnimals.shape.Cow.options;
    }
    return undefined;
};
